import React from "react";
import TextAreaList from "../../TextareaComponent/TextAreaList";

export function AddListModal({
  addTextAreaField = () => {},
  removeTextAreaField = () => {},
  handleCloseAddListModal = () => {},
  handleChangeTextAreaDetails = () => {},
  handleChangeSubjectDetails = () => {},
  saveTempList = () => {},
  selectedTempList = [],
  method
}) {
  return (
    <div id="patientAddListModal" className="modal" tabIndex="-1" role="dialog">
      <div
        className="modal-dialog modal-print"
        role="document"
        style={{ zIndex: "1050" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="hc-primary-text" style={{ fontSize: "1.25rem" }}>
              List Details
            </h5>
          </div>
          <div className="modal-body">
            <div className="rx-input-container input-handler">
              <TextAreaList
                data={selectedTempList}
                handleChangeTextAreaDetails={handleChangeTextAreaDetails}
                handleChangeSubjectDetails={handleChangeSubjectDetails}
                addTextAreaField={addTextAreaField}
                removeTextAreaField={removeTextAreaField}
                method={method}
                labels={{
                  prop: "body",
                  placeholder: "body"
                }}
                hasSubject={true}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-hubchart btn-hubchart-primary"
              onClick={() => saveTempList(selectedTempList)}
            >
              Done
            </button>
            <button
              type="button"
              className="btn btn-hubchart btn-hubchart-close"
              onClick={() => handleCloseAddListModal()}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddListModal;
